<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.display {
  display: flex;
}
.display2 {
  display: flex;
  align-items: center;
}
.display3 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.displayA {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.displayB {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/App.vue